export default "__VITE_ASSET__Crh5O5gw__"